import { useContext } from 'react';
import AccountContext from '../context/AccountContext';
import { AccountResponse } from '../structures/response/AccountResponse';
import { ownAccount } from '../api/user';
import useClosableSnackbar from './useClosableSnackbar';

export default function useAccount(): {
  accountResponse: AccountResponse | null;
  updateAccountResponse: (v: AccountResponse) => void;
  fetchAccountResponse: () => Promise<AccountResponse | null>;
} {
  const { setAccountResponse, accountResponse } = useContext(AccountContext);
  const { showSnackbar } = useClosableSnackbar();

  function updateAccountResponse(v: AccountResponse) {
    setAccountResponse(v);
    localStorage.setItem('user', JSON.stringify(v));
  }

  async function fetchAccountResponse() {
    try {
      const r = await ownAccount();
      updateAccountResponse(r);
      return r;
    } catch (e) {
      showSnackbar('Ошибка получения данных аккаунта');
      console.log(e);
    }
    return null;
  }

  return { accountResponse, updateAccountResponse, fetchAccountResponse };
}
